import { GALLERY } from "@/lib/content";

export default function Gallery() {
  return (
    <section
      id="realisations"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-[#F3F4F1] grain-bg"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-4xl">
          <div>
            <div className="text-xs uppercase tracking-widest font-semibold text-[#5C635A]">
              — Réalisations
            </div>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-[#1E2320] leading-tight">
              Nos chantiers parlent
              <br />
              <span className="text-[#1A4331]">pour nous.</span>
            </h2>
          </div>
          <p className="md:max-w-sm text-base text-[#5C635A] leading-relaxed">
            Un aperçu de nos interventions récentes en copropriété, bureaux et propriétés privées.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-4 md:gap-5">
          {GALLERY.map((item, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-2xl bg-[#1A4331]/5 ${item.span || ""}`}
            >
              <img
                src={item.url}
                alt={item.alt}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-90" />
              <figcaption className="absolute bottom-4 left-4 right-4 flex items-center justify-between gap-2">
                <span className="text-white text-sm font-medium">{item.alt}</span>
                <span className="text-[10px] uppercase tracking-widest px-2.5 py-1 rounded-full bg-white/95 text-[#1A4331] font-semibold">
                  {item.tag}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
